(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/results/assets/javascripts/radio/campaign.js') >= 0) return;  svs.modules.push('/components/numbergames/results/assets/javascripts/radio/campaign.js');

'use strict';

const {
  campaign: {
    asyncCampaignApi,
    asyncOpenCampaignApi,
    CONSTANTS: CAMPAIGN_CONSTANTS
  }
} = svs.numbergames;
svs.numbergames.results.radio.campaign = Backbone.Radio.channel('campaign');
svs.numbergames.results.radio.campaign.reply('campaign', async _ref => {
  let {
    productId,
    date
  } = _ref;
  const drawTypeId = CAMPAIGN_CONSTANTS.DRAW_TYPE.CAMPAIGN;
  const campaignByDate = await asyncCampaignApi.getCampaign(productId, {
    date,
    drawTypeId
  });
  if (campaignByDate) {
    return campaignByDate;
  }
  const openCampaign = await asyncOpenCampaignApi.getCampaign(productId, {
    drawTypeId
  });
  if (openCampaign) {
    return openCampaign;
  }
  const today = new Date(svs.numbergames.data.results.todayDateString);
  const sevenDaysAgo = new Date(today);
  sevenDaysAgo.setDate(today.getDate() - 7);
  const endDateInterval = {
    start: sevenDaysAgo,
    end: today
  };
  if (dateFns.isWithinInterval(new Date(date), endDateInterval)) {
    const recentlyClosedCampaign = await asyncCampaignApi.getCampaign(productId, {
      endDateInterval,
      drawTypeId
    });
    if (recentlyClosedCampaign) {
      return recentlyClosedCampaign;
    }
  }
});

 })(window);